import { createFileRoute } from '@tanstack/react-router';
import TerminalContactMergeView from '../terminal/ManageTerminalContactsView/components/TerminalContactMergeView';
export const Route = createFileRoute(
  '/terminals/locations/$terminalId_/contacts/$contactId_/merge',
)({ component: TerminalContactMergeView });
